import type { NightPayload } from "../premises_census";

// The moments the chart flags over the night: the roll call now, incidents
// later. A marker is a few pixels wide, so a drag within reach of one snaps
// onto it, and the badge names whichever one the cursor sits on.
export type MarkerKind = "roll_call";

export interface Marker {
  kind: MarkerKind;
  at: number;
}

export class Markers {
  private readonly list: Marker[];

  constructor(night: NightPayload) {
    this.list = night.rollCallAt === null ? [] : [{ kind: "roll_call", at: night.rollCallAt }];
  }

  // The nearest marker no more than `reach` seconds from `seconds`.
  near(seconds: number, reach: number): Marker | null {
    let nearest: Marker | null = null;
    for (const marker of this.list) {
      const gap = Math.abs(marker.at - seconds);
      if (gap <= reach && (!nearest || gap < Math.abs(nearest.at - seconds))) nearest = marker;
    }
    return nearest;
  }

  snap(seconds: number, reach: number): number {
    return this.near(seconds, reach)?.at ?? seconds;
  }
}
